import { Directive, Input, ElementRef, HostListener } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { fromEvent } from 'rxjs';


@Directive({
  selector: '[appInvalidControlScroll]'
})
export class InvalidControlScrollDirective {

  @Input() controlClass: string;

  constructor(private elementRef: ElementRef, private formGroupDir: FormGroupDirective) { }

  @HostListener('click') onClick() {
    fromEvent(document, 'click').subscribe((ev: Event) => {
      const element = ev.target as HTMLElement;
      if (element.innerHTML.includes('Siguiente') && this.formGroupDir.invalid) {
        this.scrollToFirstInvalidControl();
      }
    });
  }


  scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.elementRef.nativeElement.querySelector(
      this.controlClass + '.ng-touched.ng-invalid',
    );
    if (firstInvalidControl === null || firstInvalidControl === undefined) {
      return;
    }

    window.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: 'smooth'
    });
  }

  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }

}
